import { useModalState } from '../../../../hooks/useModalState';
import LangEnum from '../../../../lang/LangEnum';
import snackbarStore from '../../../../stores/Snackbar.store';
import { useTranslation } from '../../../translation/TranslationContext';
import { useOfflineDataDownloader } from '../useOfflineDataDownloader/useOfflineDataDownloader';

export const useOfflineDownloaderWithModal = () => {
  const { translate } = useTranslation();
  const { handleMessage } = snackbarStore;

  const {
    isOpen: isOpenOfflineModal,
    openModal: openOfflineModal,
    closeModal: closeOfflineModal,
  } = useModalState();

  const offlineDataDownloader = useOfflineDataDownloader();

  const handleDownloadOfflineData = async () => {
    closeOfflineModal();
    await offlineDataDownloader.downloadData();
  };

  const handleRemoveOfflineData = async () => {
    closeOfflineModal();

    try {
      await offlineDataDownloader.removeOfflineData();

      handleMessage({
        type: 'success',
        message: translate(LangEnum.GLOBAL_DATA_DELETED_SUCCESSFULLY),
      });
    } catch (_error) {
      handleMessage({
        type: 'error',
        message: translate(LangEnum.OFFLINE_REMOVE_DATA_ERROR),
      });
    }
  };

  const updateOfflineData = async () => {
    closeOfflineModal();

    await offlineDataDownloader.updateOfflineData();
  };

  return {
    openOfflineModal,
    closeOfflineModal,
    updateOfflineData,
    isOpenOfflineModal,
    handleRemoveOfflineData,
    handleDownloadOfflineData,
    isSyncing: offlineDataDownloader.isSyncing,
    lastSyncedAt: offlineDataDownloader.lastSyncedAt,
    hasSyncedData: offlineDataDownloader.hasSyncedData,
    totalSyncedPercentage: offlineDataDownloader.totalSyncedPercentage,
  };
};
